import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CompetitionDocumentsRoutingModule } from './competition-documents-routing.module';
import { BootstrapCompetitionDocumentsComponent } from './components/bootstrap-competition-documents/bootstrap-competition-documents.component';
import { CommonPageComponentsModule } from '../../common-page-components/common-page-components.module';
import { CoreModule } from '../../library/core.module';
import { CompetitionDocumentsFilterService } from './services/competition-documents-filter.service';


@NgModule({
  declarations: [BootstrapCompetitionDocumentsComponent],
  imports: [
    CommonModule,
    CommonPageComponentsModule,
    CoreModule,
    CompetitionDocumentsRoutingModule
  ],
  providers:[
    CompetitionDocumentsFilterService
  ],
  exports:[
    BootstrapCompetitionDocumentsComponent
  ]

})
export class CompetitionDocumentsModule { }
